import generateNumberVariations from "@/components/FpAppV4/services/generateNumberVariations";

function escapeRegex(str: string) {
  return str.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&");
}

const excludedTags = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "multiplecitations",
  "citation",
  "editor-highlight-number",
  "editorhighlightnumber",
  "editorHighlightNumber",
  "numeric-citation",
];

const getExcludePattern = () => {
  const excludeSubstrings = [
    "page number",
    "page",
    "pages",
    "page numbers",
    "table",
    "tables",
    "figure",
    "figures",
    "chart",
    "chart numbers",
    "S&P ",
    "S&P",
    "Russell ",
    "Russell",
  ];
  const getAllMonthsNames = () => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let list = months.concat(months.map((month) => month.toLowerCase()));
    list.push(...list.map((month) => month + " "));
    return list;
  };

  const allMonthsNames = getAllMonthsNames();
  return `${allMonthsNames.join("|")}|${excludeSubstrings.join("|")}`;
};

const isValidReference = (word: string) => {
  if (word && word.length > 0) {
    const newWord = word.replace("0", "");
    if (newWord.length === 0) {
      return false;
    }
    return true;
  }
  return false;
};

function wrapNumericReference(
  referencedNumbers: string[],
  htmlContent: string,
  qid: string
) {
  referencedNumbers = referencedNumbers.map((numValue) => "" + numValue);
  referencedNumbers.sort((a, b) => b.length - a.length);
  referencedNumbers = referencedNumbers.filter((numValue) => {
    return isValidReference(numValue);
  });

  const element = document.createElement("template");
  element.innerHTML = htmlContent;

  for (const node of element.content.childNodes) {
    if (node instanceof HTMLElement) {
      wrapNumericReferenceOnNode(node, referencedNumbers, qid);
    }
  }

  return element.innerHTML;
}

const isOfExcludedWordFormat = (word: string) => {
  let isExcluded = false;

  if (!word) return true;

  // word should not be of date format like 12/12/2024
  const dateType1Regex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  if (dateType1Regex.test(word)) {
    isExcluded = true;
  }

  // word should not be of date format like 12 March 2022
  const dateType2Regex = /^\d{1,2} \w+ \d{4}$/;
  if (dateType2Regex.test(word)) {
    isExcluded = true;
  }

  // word should not be of date format like Mar 12, 2022
  const dateType3Regex = /^\w{3} \d{1,2}, \d{4}$/;
  if (dateType3Regex.test(word)) {
    isExcluded = true;
  }

  return isExcluded;
};

const wrapNumericReferenceOnNode = (
  node: HTMLElement | Text,
  referencedNumbers: string[],
  qid: string
) => {
  const excludePattern = getExcludePattern();
  if (node instanceof HTMLElement) {
    const tagName = node.tagName.toLowerCase();
    if (excludedTags.includes(tagName)) {
      return;
    }

    if (node.childNodes.length > 0) {
      for (const child of node.childNodes) {
        if (child instanceof HTMLElement) {
          wrapNumericReferenceOnNode(child, referencedNumbers, qid);
        }
        if (child instanceof Text) {
          wrapNumericReferenceOnNode(child, referencedNumbers, qid);
        }
      }
      return;
    }
  }
  let word = (node.textContent || "").trim();
  if (isOfExcludedWordFormat(word)) {
    return;
  }

  // console.log(word);

  referencedNumbers.forEach((numValue) => {
    const numValueVariations = generateNumberVariations(numValue);
    const textLength = word?.length || 0;
    for (const variation of numValueVariations) {
      if (!isValidReference(variation)) {
        continue;
      }
      const escapedValue = escapeRegex(variation);
      const regex = new RegExp(
        `(?<!(${excludePattern})\\s)(?<=\\s|\\$|\\(|^|\\n|>|\\/)([+-]?${escapedValue}%?)(?!\\d|\\.[\\d]|,\\d)(?=[^\\d]|$|<)`,
        "gi"
      );

      if (word) {
        word = word.replace(
          regex,
          `<editor-highlight-number numValue="${numValue}" originalNumValue="$&" qid="${qid}">${numValue}</editor-highlight-number>`
        );
      }
      if (word && word?.length > textLength) {
        // console.log(variation, " -> ", word);
        break;
      }
    }
  });

  if (node instanceof Text && word) {
    const parentElement = node.parentElement;
    const tempElement = document.createElement("span");
    tempElement.innerHTML = word;
    parentElement?.replaceChild(tempElement, node);
  }
  if (node instanceof HTMLElement && word) {
    node.innerHTML = word;
  }
};

export default wrapNumericReference;
